<template>
  <el-container>
    <el-header height="60">
      <CommonHeader />
    </el-header>
    <el-container>
      <el-aside width="auto">
        <CommonSideBar />
      </el-aside>
      <el-main>
        <transition name="on" mode="out-in">
          <router-view></router-view>
        </transition>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import CommonHeader from "../components/Common-Header"
import CommonSideBar from "../components/Common-SideBar"
export default {
  components: {
    CommonHeader,
    CommonSideBar
  }
}
</script>

<style lang="scss">
.el-header {
  box-shadow: 0px 1px 2px #dbdbdb;
  z-index: 100;
}
.el-container {
  height: 100%;
  .el-container {
    //border: 1px solid green;
    //height: calc(100% - 60px) !important;
    height: calc(100% - 68px);

    .el-aside {
      overflow: auto;
      &::-webkit-scrollbar {
        width: 7px;
        height: 7px;
        background-color: #f1f1f1;
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
        background-color: #c8c8c8;
      }
    }
    .el-main {
      overflow: auto;
      background: #f5f5f5;
      &::-webkit-scrollbar {
        width: 7px;
        height: 7px;
        background-color: #f5f5f5;
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
        background-color: #c8c8c8;
      }
    }
  }
}
.on-enter-active {
  transition: 0.3s ease;
}
.on-leave-active {
  transition: 0.3s ease;
}
.on-enter,
.on-leave-to {
  opacity: 0;
}

.slide-fade-enter-active {
  transition: all 0.35s linear;
}
.slide-fade-leave-active {
  transition: all 0.35s linear;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(-100px);
  opacity: 0;
}
</style>
